module.exports = __webpack_public_path__ + "static/img/20020 (3).e0f97b5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20020 (3).webp
// module id = vApm
// module chunks = 14